import React, { useState, lazy } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { FadeIn } from './FadeIn';
const RESULTS = [{
  src: 'https://cdn.magicpatterns.com/uploads/oQU8Q8NZeAeVVvGd1jj6P1/Gemini_Generated_Image_e0oqbre0oqbre0oq.png',
  alt: 'Comparación antes y después siguiendo el método Airfryer Fit'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/psawcFUNUicqN1bL9sAzHq/ChatGPT_Image_10_jun_2026,_01_40_24_p.m..png',
  alt: 'Comparación antes y después de otra persona siguiendo el método Airfryer Fit'
}];
export function ResultsSection() {
  const [index, setIndex] = useState(0);
  const go = (dir: number) => {
    setIndex(prev => (prev + dir + RESULTS.length) % RESULTS.length);
  };
  return <section className="py-20 bg-brand-50" data-id="element-240">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-241">
        <FadeIn data-id="element-242">
          <div className="text-center mb-10" data-id="element-243">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-100 text-emerald-700 font-semibold text-sm mb-4" data-id="element-244">
              Resultados reales
            </div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-stone-900" data-id="element-245">
              Pequeños cambios, grandes transformaciones
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} direction="up" data-id="element-246">
          <div className="relative" data-id="element-247">
            <figure className="rounded-3xl overflow-hidden shadow-xl bg-white p-2" data-id="element-248">
              <div className="relative rounded-2xl overflow-hidden aspect-[3/2]" data-id="element-249">
                <AnimatePresence mode="wait" data-id="element-250">
                  <motion.img key={index} src={RESULTS[index].src} alt={RESULTS[index].alt} width={1500} height={1000} loading="lazy" decoding="async" initial={{
                  opacity: 0,
                  x: 30
                }} animate={{
                  opacity: 1,
                  x: 0
                }} exit={{
                  opacity: 0,
                  x: -30
                }} transition={{
                  duration: 0.35,
                  ease: [0.21, 0.47, 0.32, 0.98]
                }} className="absolute inset-0 w-full h-full object-cover" data-id="element-251" />
                </AnimatePresence>
              </div>
            </figure>

            {/* Arrows */}
            <button onClick={() => go(-1)} aria-label="Imagen anterior" className="absolute left-2 md:-left-5 top-1/2 -translate-y-1/2 bg-white text-stone-700 hover:text-brand-600 w-11 h-11 rounded-full shadow-lg flex items-center justify-center transition-colors hover:scale-105" data-id="element-252">
              <ChevronLeft className="w-6 h-6" data-id="element-253" />
            </button>
            <button onClick={() => go(1)} aria-label="Imagen siguiente" className="absolute right-2 md:-right-5 top-1/2 -translate-y-1/2 bg-white text-stone-700 hover:text-brand-600 w-11 h-11 rounded-full shadow-lg flex items-center justify-center transition-colors hover:scale-105" data-id="element-254">
              <ChevronRight className="w-6 h-6" data-id="element-255" />
            </button>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-5" data-id="element-256">
            {RESULTS.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Ver resultado ${i + 1}`} className={`h-2.5 rounded-full transition-all ${i === index ? 'w-7 bg-brand-600' : 'w-2.5 bg-stone-300 hover:bg-stone-400'}`} data-id="element-257" />)}
          </div>

          <figcaption className="text-center text-sm text-stone-500 max-w-2xl mx-auto mt-5 leading-relaxed" data-id="element-258">
            Los resultados varían según cada persona. El objetivo del método es
            ayudarte a crear hábitos alimenticios más saludables y sostenibles.
          </figcaption>
        </FadeIn>
      </div>
    </section>;
}